/**
 * Chặn thao tác cho tới khi đổi mật khẩu — dùng cho tài khoản GV được trường
 * bulk-import kèm mật khẩu tạm (Phase 5.4, xem SchoolBulkImportService).
 * Cờ `EDUAPP_REQUIRES_PW_CHANGE` được Login.tsx set sau khi đăng nhập, dựa
 * trên `requiresPasswordChange` trả về từ AuthController::login().
 */
import React, { useState } from 'react';
import { changePasswordApi } from '../../services/apiService';
import { ExclamationTriangleIcon } from './Icons';
import Spinner from './Spinner';

const MustChangePasswordModal: React.FC<{ onDone: () => void }> = ({ onDone }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        setError('');
        if (newPassword.length < 8) { setError('Mật khẩu mới phải từ 8 ký tự.'); return; }
        if (newPassword !== confirmPassword) { setError('Xác nhận mật khẩu không khớp.'); return; }

        setIsSubmitting(true);
        const result = await changePasswordApi(currentPassword, newPassword);
        setIsSubmitting(false);
        if (!result.changed) { setError(result.error || 'Không thể đổi mật khẩu.'); return; }

        try { localStorage.removeItem('EDUAPP_REQUIRES_PW_CHANGE'); } catch {}
        onDone();
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-70 p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
                <div className="w-14 h-14 bg-amber-100 text-amber-600 rounded-2xl flex items-center justify-center mx-auto mb-5">
                    <ExclamationTriangleIcon className="h-7 w-7" />
                </div>
                <h2 className="text-lg font-black text-slate-800 text-center mb-2">Cần đổi mật khẩu</h2>
                <p className="text-sm text-slate-500 text-center mb-6">
                    Tài khoản của bạn đang dùng mật khẩu tạm do trường cấp — hãy đặt mật khẩu mới trước khi tiếp tục.
                </p>
                <div className="space-y-3">
                    <div>
                        <label className="block text-xs font-semibold text-slate-500 mb-1">Mật khẩu tạm (hiện tại)</label>
                        <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="w-full p-3 bg-slate-50 border-2 border-slate-100 rounded-xl focus:border-indigo-500 focus:bg-white transition-all text-sm" />
                    </div>
                    <div>
                        <label className="block text-xs font-semibold text-slate-500 mb-1">Mật khẩu mới</label>
                        <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full p-3 bg-slate-50 border-2 border-slate-100 rounded-xl focus:border-indigo-500 focus:bg-white transition-all text-sm" />
                    </div>
                    <div>
                        <label className="block text-xs font-semibold text-slate-500 mb-1">Xác nhận mật khẩu mới</label>
                        <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full p-3 bg-slate-50 border-2 border-slate-100 rounded-xl focus:border-indigo-500 focus:bg-white transition-all text-sm" />
                    </div>
                    {error && <p className="text-xs font-bold text-rose-600">{error}</p>}
                </div>
                <button
                    onClick={handleSubmit}
                    disabled={isSubmitting || !currentPassword || !newPassword || !confirmPassword}
                    className="mt-6 w-full py-3 bg-indigo-600 text-white font-black text-xs uppercase tracking-widest rounded-2xl hover:bg-indigo-700 shadow-lg shadow-indigo-100 active:scale-95 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                >
                    {isSubmitting && <Spinner className="h-4 w-4" />}
                    <span>Đổi mật khẩu</span>
                </button>
            </div>
        </div>
    );
};

export default MustChangePasswordModal;
